import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import CommonLayout from "../commoncomponents/layout/CommonLayout";
import Container from "@mui/material/Container";

const ThankYou = () => {
  return (
    <CommonLayout footer={false} hideButtons={false}>
      <Container component="main" maxWidth="lg" sx={{ mt: 4 }}>
        <Grid item md={12}>
          <br />
        </Grid>

        <Grid item md={12}>
          <Typography
            style={{ fontSize: "20px", fontWeight: "bold", color: "#1b99d6" }}
          >
            Thank you for registering to cellmaflex. Some one from team will
            email you within 24 hrs
          </Typography>
        </Grid>
      </Container>
    </CommonLayout>
  );
};

export default ThankYou;
